import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-32 text-center">
      <div className="section-label">// 0x404</div>
      <h1 className="mt-3 font-display text-6xl md:text-9xl tracking-tighter leading-none">404</h1>
      <p className="mt-6 font-mono text-[11px] tracking-[0.2em] uppercase text-[#a3a3a3]">
        // file not found in the mainframe
      </p>
      <p className="mt-3 text-[#a3a3a3] max-w-md mx-auto">
        The transmission you requested does not exist. Return to the catalog or authorize uplink for the next drop.
      </p>
      <div className="mt-10 flex gap-3 justify-center flex-wrap">
        <Link to="/" className="btn-primary">
          Back to Home <ArrowRight size={14} strokeWidth={1.5} />
        </Link>
        <Link to="/shop" className="btn-outline">
          Catalog
        </Link>
      </div>
    </div>
  );
}
